import { RouteConfig } from "vue-router";

export const RPasswordReset: RouteConfig = {
  path: "password_reset",
  name: "PasswordReset",
  component: () =>
    import(
      /* webpackChunkName: "auth-password_reset" */
      "./VPasswordReset.vue"
    ),
  meta: {
    auth: false,
  },
};
